import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../GlobalServices/Destinations/Destinations.css";
import "../Experience/experience.css";
import Heading from "../../../utls/Heading";

const Experience = () => {
  return (
    <>
      <div className="Destination">
        <div className="container ServiceOffering">
          <div className="row">
            <div className="col-md-12 ">
              <div className="d-flex px-md-5 px-2 flex-column">
                <Heading className="headings ">
                  <span>Experience </span>Travel Like Never Before
                </Heading>
                <p className="heading-para grotesk-headings w-100">
                  No matter what your desired entertainment travel experience
                  is, we are here to make it come true. Our team of
                  knowledgeable travel specialists takes great pleasure in
                  creating unforgettable journeys for their clients.
                </p>
              </div>
            </div>
          </div>
          <div className="row px-lg-5 px-md-0 px-4 mlTab  ">
            <div className="col-lg-4 col-md-4 col-12  mt-3 d-flex justify-content-center">
              <div className="DT-box1 ">
                <div className="row">
                  <div className="col-md-12">
                    <div className="Destinations-img d-flex justify-content-center">
                      <LazyLoadImage
                        src="https://blueberrywebsites.azureedge.net/bbt/images/enter1.svg"
                        alt=""
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings text-center desti-head-enter">
                      VISA AND PASSPORT
                    </h5>
                    <p className="mt-3 text-center desti-para grotesk-headings">
                      We simplify your international travel by handling visas
                      and passports, ensuring you’re ready for every travel
                      adventure.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12  mt-3  d-flex justify-content-center">
              <div className="DT-box1 DT-box2">
                <div className="row">
                  <div className="col-md-12">
                    <div className="Destinations-img d-flex justify-content-center">
                      <LazyLoadImage
                        src="https://blueberrywebsites.azureedge.net/bbt/images/enter2.svg"
                        alt=""
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings text-center desti-head-enter">
                      CONCIERGE SERVICES
                    </h5>
                    <p className="mt-3 text-center desti-para grotesk-headings">
                      From restaurant reservations to tour bookings and lost
                      luggage support, our team takes care of them so you can
                      enjoy your journey.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12  mt-3  d-flex justify-content-center">
              <div className="DT-box1 DT-box3 ">
                <div className="row">
                  <div className="col-md-12">
                    <div className="Destinations-img d-flex justify-content-center">
                      <LazyLoadImage
                        src="https://blueberrywebsites.azureedge.net/bbt/images/enter4.svg"
                        alt=""
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings text-center desti-head-enter">
                      PLANNING ITINERARY
                    </h5>
                    <p className="mt-3 text-center desti-para grotesk-headings">
                      Let our travel experts craft an itinerary that suits your
                      interests, budget, and time. Hence, creating a perfect
                      travel experience.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Experience;
